export default __webpack_public_path__ + "static/media/wand-train.e765ed18.webp";